import React, { ComponentType, ReactNode } from "react";

import cn from "classnames";

import styles from "./Interactive.module.scss";

interface Props {
  children: ReactNode;
  className?: string;
  id?: string;
  tag?: ComponentType<{ className?: string; id?: string }> | keyof JSX.IntrinsicElements;
}

const Interactive = ({ id, children, className, tag: Tag = "div" }: Props) => (
  <Tag className={cn(styles.container, className)} id={id}>
    {children}
  </Tag>
);

export default Interactive;
